<template>
  <div id="right-sidebar" class="settings-panel">
    <div class="tab-content" id="setting-content"></div>
  </div>

  <nav class="sidebar sidebar-offcanvas" id="sidebar">
    <ul class="nav">
      <li class="nav-item">
        <a class="nav-link" href="/">
          <i class="icon-layout menu-icon"></i>
          <span class="menu-title">หน้าหลัก</span>
        </a>
      </li>

      <li class="nav-item">
        <a
          class="nav-link"
          data-toggle="collapse"
          href="#ui-basic"
          aria-expanded="false"
          aria-controls="ui-basic"
        >
          <i class="icon-layout menu-icon"></i>
          <span class="menu-title">สาขาที่เปิด</span>
          <i class="menu-arrow"></i>
        </a>
        <div class="collapse" id="ui-basic">
          <ul class="nav flex-column sub-menu">
            <div class="col-12">
              <li class="nav-item text_l">
                <a
                  class="card"
                  target="_blank"
                  href="https://openhouse.rmuti.ac.th/Business.html"
                  ><h5>คณะบริหารธุรกิจ</h5></a
                >
              </li>
              <li class="nav-item text_l">
                <a
                  class="card"
                  target="_blank"
                  href="https://openhouse.rmuti.ac.th/Science.html"
                  ><h5>คณะวิทยาศาสตร์และศิลปศาสตร์</h5></a
                >
              </li>
              <li class="nav-item text_l">
                <a
                  class="card"
                  target="_blank"
                  href="https://openhouse.rmuti.ac.th/Engineer.html"
                  ><h5>คณะวิศวกรรมศาสตร์และเทคโนโลยี</h5></a
                >
              </li>
              <li class="nav-item text_l">
                <a
                  class="card"
                  target="_blank"
                  href="https://openhouse.rmuti.ac.th/Art.html"
                  ><h5>คณะสถาปัตยกรรมศาสตร์และศิลปกรรมสร้างสรรค์</h5></a
                >
              </li>
              <li class="nav-item text_l">
                <a
                  class="card"
                  target="_blank"
                  href="https://openhouse.rmuti.ac.th/Iis.html"
                  ><h5>สถาบันสหสรรพศาสตร์</h5></a
                >
              </li>
            </div>
          </ul>
        </div>
      </li>

      <!-- <li class="nav-item">
        <a href="https://www.freecounterstat.com" title="website hits counter"
          ><img
            src="https://counter5.optistats.ovh/private/freecounterstat.php?c=qrm3db9pnykn8fb7dpbkdal3s54kxrte"
            border="0"
            title="website hits counter"
            alt="website hits counter"
        /></a>
      </li> -->
    </ul>
  </nav>
</template>

<script>
export default {
  name: "SideNavRight",
};
</script>

<style scoped>
/* .sidebar {
  background: #e5f9fe;
} */
.sidebar .nav.sub-menu {
  margin-bottom: 0;
  margin-top: 0;
  list-style: none;
  padding: 0 0 0 0;
  background: #4b49ac;
  padding-bottom: 12px;
  border-radius: 5px;
}
/* .sidebar .nav.sub-menu .nav-item .nav-link {
  color: #fff;
  padding: 0.7rem 1rem;
  position: relative;
  font-size: 0.875rem;
  line-height: 1;
  height: auto;
  width: 50%;
  border-top: 0;
  border-radius: 10px;
} */
/* .text_l {
  word-wrap: break-word;
} */
h5 {
  text-align: center;
  line-height: 1.5rem;
  text-shadow: 2px 2px 8px #000000;
}
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  color: rgb(255, 255, 255);
  background-color: #4b49ac;
  background-clip: border-box;
  border: 1px solid #e3e3e3;
  border-radius: 10px;
  margin-top: 10px;
}
</style>
